module.exports = __webpack_public_path__ + "static/media/pov_alternative_polytope_5_3_3_cell120.70243797.png";